import Sidebar from 'src/components/Sidebar/Sidebar.component';
import type { tProvidersProps } from '../Layout.types';
import PrivateLayoutFrame from './PrivateLayoutFrame.component';

export default function PrivateLayout(props: tProvidersProps) {
  return (
    <PrivateLayoutFrame sidebar={<Sidebar />}>
      {props.children}
    </PrivateLayoutFrame>
  );
}
